import React from 'react';
import { BRAND_NAME } from '../brand';

/**
 * The platform logo mark — slate-900 270° arc with a blue checkmark inside.
 * Defaults to the size used in the in-app top nav. Use sizeClass to override
 * (e.g. "h-12 w-12" for a sign-in screen).
 */
export const LogoMark = ({ sizeClass = 'h-8 w-8', className = '' }) => (
  <svg
    viewBox="0 0 120 120"
    className={`${sizeClass} ${className}`.trim()}
    aria-hidden="true"
  >
    <path
      d="M60 20 A40 40 0 1 0 100 60"
      stroke="#1E293B"
      strokeWidth="10"
      fill="none"
      strokeLinecap="square"
    />
    <path
      d="M40 62 L56 78 L88 42"
      stroke="#2563EB"
      strokeWidth="12"
      fill="none"
      strokeLinecap="square"
      strokeLinejoin="miter"
    />
  </svg>
);

/**
 * Mark + platform wordmark side by side. Used in nav bars + the landing
 * page header/footer. The wordmark is the brand name (brand.js).
 */
export const Logo = ({ sizeClass = 'h-8 w-8', textClass = 'text-lg' }) => (
  <div className="flex items-center gap-2">
    <LogoMark sizeClass={sizeClass} />
    <span className={`${textClass} font-bold tracking-tight text-foreground`}>
      {BRAND_NAME}
    </span>
  </div>
);
